import React from 'react'

import { Page, View, Text, Image } from '@react-pdf/renderer'
import styles from '../style'

import lineFade from '../assets/line_fade.png'
import linePurpleFade from '../assets/line_purple_fade.png'
import angleFull from '../assets/angle_full.png'

interface ICoverPageProps {
  quoteId: string | number
  groupName: string
  effectiveDate: string
}

const CoverPage = ({ quoteId, groupName, effectiveDate }: ICoverPageProps) => {

  const calcGroupNameTitleFontSize = () => {
    if (groupName.length > 33) {
      return 22
    } else if (groupName.length <= 26) {
      return 28;
    } else {
      return 28 - Math.ceil((6/7) * (groupName.length-26))
    }
  }

  const groupNameTitleFontSize = calcGroupNameTitleFontSize()

  return (
    <Page style={{ display: 'flex' }}>
      <View style={{ padding: 40, backgroundColor: '#6D39D9', flex: 10 }}>
        <View style={styles.row}>
          <Image src={lineFade} />
          <Image src={angleFull} style={{ width: 90, marginLeft: 40 }} />
        </View>
        <View
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Text
            style={{
              fontSize: 60,
              color: 'white'
            }}
          >
            {'Health Insurance for the Modern\nEmployee'}
          </Text>
        </View>
      </View>
      <View
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 2,
          color: '#6D39D9',
          paddingVertical: 20,
          paddingHorizontal: 40
        }}
      >
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flex: 1,
            fontSize: 11
          }}
        >
          <View>
            <Text
              style={{
                letterSpacing: 1.1
              }}
            >
              PREPARED FOR:
            </Text>
            <Text
              style={{
                fontSize: groupNameTitleFontSize,
                marginTop: 20,
                width: '70%'
              }}
            >
              {groupName}
            </Text>
          </View>
          <View>
            <Text
              style={{
                letterSpacing: 1.1
              }}
            >
              EFFECTIVE DATE:
            </Text>
            <Text
              style={{
                fontSize: 28,
                marginTop: 20
              }}
            >
              {effectiveDate}
            </Text>
          </View>
        </View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: 10
          }}
        >
          <Text>SALES@ANGLEHEALTH.COM</Text>
          <Image
            src={linePurpleFade}
            style={{
              height: 1,
              flex: 1,
              marginHorizontal: 40
            }}
          />
          <Text>QUOTE ID: {quoteId}</Text>
        </View>
      </View>
    </Page>
  )
}

export default CoverPage
